import { render, staticRenderFns } from "./AlternativeCreationQuestion.vue?vue&type=template&id=4af1682e&scoped=true"
import script from "./AlternativeCreationQuestion.vue?vue&type=script&lang=js"
export * from "./AlternativeCreationQuestion.vue?vue&type=script&lang=js"
import style0 from "./AlternativeCreationQuestion.vue?vue&type=style&index=0&id=4af1682e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af1682e",
  null
  
)

export default component.exports